import styled from 'styled-components';

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export default ButtonContainer;
